import * as firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/functions';
import 'firebase/messaging';

class FireBase {
  constructor() {
    firebase.initializeApp({
      apiKey: process.env.VUE_APP_apiKey,
      authDomain: process.env.VUE_APP_authDomain,
      databaseURL: process.env.VUE_APP_databaseURL,
      projectId: process.env.VUE_APP_projectId,
      storageBucket: process.env.VUE_APP_storageBucket,
      appId: process.env.VUE_APP_appId,
      messagingSenderId: process.env.VUE_APP_messagingSenderId,
    });
    this.db = firebase.firestore();
    const messaging = firebase.messaging();
    messaging.usePublicVapidKey(process.env.VUE_APP_vapidKey);
    this.messaging = messaging;
    this.instance = firebase;
  }
}

const firebaseInstance = new FireBase();
Object.freeze(firebaseInstance);

export default firebaseInstance;
